// @ts-strict-ignore
import React from 'react'
import { useNavigation } from '@react-navigation/native'
import { Divider } from 'react-native-elements'
import styled from 'styled-components/native'

import I18n from 'APP/I18n'
import {
  ICONS_MAPPING,
  buildNotificationCenterData,
  type Preferences,
} from 'APP/Lib/PreferenceHelpers'
import List from 'APP/Components/List'
import LogoHeader from 'APP/Components/LogoHeader'
import ListItem from 'APP/Converse/ListItem'
import Typography from 'APP/Converse/Typography'

const ContentContainer = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const NotificationCenter = ({ preferences }: { preferences: Preferences }) => {
  const navigation = useNavigation()
  const data = buildNotificationCenterData(preferences) || []

  const renderListItem = (key: string) => {
    const titleKey = `NotificationsScreen.notificationCenter.${key}.title`
    const typesKey = `NotificationsScreen.notificationCenter.${key}.types`

    if (!I18n.exists(titleKey) || !I18n.exists(typesKey)) return null

    return (
      <ListItem
        key={key}
        leftIconName={ICONS_MAPPING[key as keyof typeof ICONS_MAPPING]}
        title={I18n.t(titleKey)}
        titleVariant={'subheader'}
        subtitle={I18n.t(typesKey)}
        iconName="chevron-right"
        onPress={() =>
          navigation.navigate('notificationDetail', {
            notification: key,
          })
        }
      />
    )
  }

  return (
    <ContentContainer testID="NOTIFICATION_CENTER">
      <LogoHeader
        title={I18n.t('NotificationsScreen.notificationCenter.title')}
        titleVariant="h2"
        subtitle={
          <Typography variant="bodySmall">
            {I18n.t('NotificationsScreen.notificationCenter.subtitle')}
          </Typography>
        }
      />

      {data && <List>{data.map((key) => renderListItem(key))}</List>}

      <Divider />

      <Typography variant="bodySmall">
        {I18n.t('NotificationsScreen.notificationCenter.habitReminder')}
      </Typography>
    </ContentContainer>
  )
}
